import { Component, OnInit, ViewChild } from "@angular/core";
import { GraphQLClient } from '../../../shared/services/graph-qlclient.service';
import gql from 'graphql-tag';
import { Observable } from 'apollo-client/util/Observable';
import { Observer, Subject } from 'rxjs';
import { rol } from '../../../shared/object/roles.model';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { categoria_modulo } from 'src/app/shared/object/categoria_modulo.model';
import { modulo } from 'src/app/shared/object/modulo.model';
import { operacion } from 'src/app/shared/object/operaciones.model';
import { operacion_moduloJoin } from 'src/app/shared/object/operacion_moduloJoin.model';
import { rol_operacionJoin } from 'src/app/shared/object/rol_operacionJoin.model';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ValidadoresService } from 'src/app/shared/validadores/validadores';
import { NotificacionGenerica } from 'src/Wheel.Styles.HighVolume/Notificacion';
import { TipoMensaje } from 'src/Wheel.Styles.HighVolume/Mensaje';

@Component({
  selector: "app-roles",
  templateUrl: "./roles.component.html",
  styleUrls: ["./roles.component.scss"],
  providers: [SecurityService, ValidadoresService]
})
export class RolesComponent implements OnInit {
  private client: GraphQLClient = null;
  optionsCategoria: Array<any> = [];
  optionsModulo: Array<any> = [];
  optionsOperacion: Array<any> = [];
  optionsClonarRol: Array<any> = [];
  rolList: rol[];
  categoriaList: categoria_modulo[];
  moduloList: modulo[];
  operacionModuloList: operacion_moduloJoin[];
  rolOperacionModuloList: rol_operacionJoin[];
  selectedRol: rol;
  rol: rol;
  formulario: FormGroup;
  formularioClon: FormGroup;
  @ViewChild('agregarRol', { static: true }) agregarModal: ModalDirective;
  @ViewChild('editarRol', { static: true }) editarModal: ModalDirective;
  @ViewChild('clonarRol', { static: true }) clonarModal: ModalDirective;
  public codgo_modulo:number = 21;
  public rut_usuario =  Number(this.accesolocalstorage.getRutUsuario());


  constructor(client: GraphQLClient, 
    private formBuilder: FormBuilder,
    private accesolocalstorage: SecurityService,
    public validadores: ValidadoresService ) {
    this.client = client;
    this.buildForm();
    this.buildFormClonar();
  }

  buildForm() {
    this.formulario = this.formBuilder.group({
      codigo: [0],
      nombre: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(30)]],
      descripcion: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]],
      activado: [true],
      categoria:[''],
      modulo: [''],
      operacion:[''],
    });
  }

  buildFormClonar() {
    this.formularioClon = this.formBuilder.group({
      codigo: [0],
      nombre: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(30)]],
      descripcion: ['', [Validators.required, Validators.minLength(5), Validators.maxLength(50)]],
      activado: [true],
      clonrol:['', [Validators.required]]
    });
  }


  ngOnInit() {
    this.selectedRol = {
      codigo: null,
      nombre: '',
      descripcion:'',
      activado: true,
      fecha_creacion: new Date()
    };
    this.obtenerDatosRol();
    this.formulario.get('categoria').valueChanges.subscribe(data=>{
      this.formulario.get('modulo').setValue('');
      this.formulario.get('operacion').setValue('');
      if(this.formulario.controls["categoria"].value=="" || this.formulario.controls["categoria"].value==undefined || this.formulario.controls["categoria"].value==null){

      }else{
        this.obtenerModulos(this.formulario.controls["categoria"].value);
      }
    });

    this.formulario.get('modulo').valueChanges.subscribe(data=>{
      this.formulario.get('operacion').setValue('');
      if(this.formulario.controls["modulo"].value=="" || this.formulario.controls["modulo"].value==undefined || this.formulario.controls["modulo"].value==null){

      }else{
        this.obtenerOperacion(this.formulario.controls["modulo"].value);
      }  
    });
  }

  showNew() {
    this.formulario.reset();
    this.formulario.get('activado').setValue(true);
    this.optionsModulo=[];
    this.optionsOperacion=[];
    this.rolOperacionModuloList = [];
    this.obtenerCategoria();
  }

  showNewClon() {
    this.formularioClon.reset();
    this.formularioClon.get('activado').setValue(true);
    this.optionsClonarRol = [];
    this.obtenerDatosRol();
  }

  showForEdit(rol: rol) {
    this.formulario.get('codigo').setValue(rol.codigo);
    this.formulario.get('nombre').setValue(rol.nombre);
    this.formulario.get('descripcion').setValue(rol.descripcion);
    this.formulario.get('activado').setValue(rol.activado);
    this.formulario.get('categoria').setValue("");
    this.formulario.get('modulo').setValue("");
    this.formulario.get('operacion').setValue("");
    this.obtenerCategoria();
    this.obtenerOperacionModuloRol(rol.codigo);
  }

  obtenerDatosRol() {
    let self = this; 
    this.client.query({
      query: gql`
      query {
        rol 
        {
          obtenerTodos {
            respuesta {
              registros {
                codigo
                nombre
                descripcion
                activado
                fecha_creacion
              }
            }
          }
        }
      }
      `,
      fetchPolicy: 'no-cache',
    },
    function(respuesta) {
      self.rolList = respuesta.data.rol.obtenerTodos.respuesta.registros;
      self.optionsClonarRol = [];
      var sel: any;
      self.rolList.forEach(element => {
        if(element.activado == true){
          sel = { value: element.codigo, label: element.nombre };
          self.optionsClonarRol.push(sel);
        }
      });
    });
  }
  insertar(rolOperacionModuloList:rol_operacionJoin[]) {
    this.selectedRol.codigo = this.formulario.controls["codigo"].value;
    this.selectedRol.nombre = this.formulario.controls["nombre"].value;
    this.selectedRol.descripcion = this.formulario.controls["descripcion"].value;
    this.selectedRol.activado = this.formulario.controls["activado"].value;
    this.postRol(this.selectedRol, rolOperacionModuloList);
  }

  insertarClon() {
    this.selectedRol.codigo = this.formularioClon.controls["codigo"].value;
    this.selectedRol.nombre = this.formularioClon.controls["nombre"].value;
    this.selectedRol.descripcion = this.formularioClon.controls["descripcion"].value;
    this.selectedRol.activado = this.formularioClon.controls["activado"].value;
    let codigoClon_rol = this.formularioClon.controls["clonrol"].value;
    this.postClonRol(this.selectedRol, codigoClon_rol);
  }

  postRol(rol:rol, rolOperacionModuloList: rol_operacionJoin[]) {
    let self = this;
    var bodyx = rol;
    this.client.mutate({
      mutation: gql`
      mutation($entidad: rolInputType)
      {
        rol{
          agregar(entidad: $entidad) {
            respuesta{
              codigo
              nombre
              descripcion
              activado
              fecha_creacion
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        if (respuesta.data.rol.agregar.respuesta != undefined) {
          setTimeout(() => self.obtenerDatosRol(), 1000);
          let codigo_rol = respuesta.data.rol.agregar.respuesta.codigo;
          self.insertarOperacion(rolOperacionModuloList, codigo_rol);
        }
      });
  }

  postClonRol(rol:rol, codigoClon_rol:number){
    let self = this;
    var bodyx = rol;
    this.client.mutate({
      mutation: gql`
      mutation($entidad: rolInputType)
      {
        rol{
          agregar(entidad: $entidad) {
            respuesta{
              codigo
              nombre
              descripcion
              activado
              fecha_creacion
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        if (respuesta.data.rol.agregar.respuesta != undefined) {
          setTimeout(() => self.obtenerDatosRol(), 1000);
          let codigo_rol = respuesta.data.rol.agregar.respuesta.codigo;
          self.insertarClonOperacion(codigoClon_rol, codigo_rol);
        }
      });
  }

  actualizar(rolOperacionModuloList:rol_operacionJoin[])
  {
      this.selectedRol.codigo = this.formulario.controls["codigo"].value;
      this.selectedRol.nombre = this.formulario.controls["nombre"].value;
      this.selectedRol.descripcion = this.formulario.controls["descripcion"].value;
      this.selectedRol.activado = this.formulario.controls["activado"].value;
      this.refrescar(this.selectedRol);
      this.refrescarOperacion(rolOperacionModuloList);
  }

  cambiaEstado(rol: rol) {
    if (rol.activado) {
      rol.activado = false;
    }
    else {
      rol.activado = true;
    }
    this.refrescar(rol);
  }

  refrescar(rol: rol) {
    let self = this;
    var bodyx = rol;
    delete rol["__typename"];
    this.client.mutate({
      mutation: gql`
      mutation($entidad: rolInputType) {
        rol {
          modificar(entidad: $entidad) {
            mensajes{
              codigo
              contexto
              texto
              tipo
            }
            respuesta{
              codigo
              nombre
              descripcion
              activado
              fecha_creacion            
            }
          }
        }
      }
      `,
      variables: {
        'entidad': bodyx,
      }
    },
      function (respuesta) {
        if (respuesta.data.rol.modificar.respuesta == null) {
          if (respuesta.data.rol.modificar.mensajes.length > 0) {
            alert(respuesta.data.rol.modificar.mensajes[0].texto);
          }
        }
        setTimeout(() => self.obtenerDatosRol(), 1000);
      });
  }

  obtenerCategoria() {
    let self = this;
    this.client.query({
      query: gql`
      query {
        categoria_modulo{
          obtenerTodos{
            respuesta{
              registros{
                codigo
                nombre
                icono
                activado
                fecha_creacion
              }
            }
          }
        }
      }
      `,
      fetchPolicy: 'network-only',
    }, function(respuesta) {
      self.categoriaList = respuesta.data.categoria_modulo.obtenerTodos.respuesta.registros;
      self.optionsCategoria = [];
      var sel: any;
      self.categoriaList.forEach(element => {
        if(element.activado == true){
          sel = { value: element.codigo, label: element.nombre };
          self.optionsCategoria.push(sel);
        }
      });
    });
  }

  obtenerModulos(codigo_categoria:number) {
    let self = this;
    this.client.query({
      query: gql`
      query($codigo_categoria:Decimal){
        modulo{
          obtenerModulosxCategorias(codigo_categoria:$codigo_categoria){
            respuesta{
              registros{
                codigo
                categoria_modulo_codigo
                nombre
                endpoint
                fecha_creacion
                activado
              }
            }
          }
        }
      }
      `,
      variables: {
        "codigo_categoria":codigo_categoria
      },
      fetchPolicy: 'no-cache',
    }, function(respuesta) {
        self.moduloList = respuesta.data.modulo.obtenerModulosxCategorias.respuesta.registros;
        self.optionsModulo = [];
        var sel: any;
        self.moduloList.forEach(element => {
          if(element.activado == true && element.endpoint!='separador'){
            sel = { value: element.codigo, label: element.nombre };
            self.optionsModulo.push(sel);
          }
        });
    });
  }

  obtenerOperacion(codigo_modulo:number) {
    let self = this;
    this.client.query({
      query: gql`
      query($codigo_modulo:Decimal){
        operacion_modulo{
          obtenerOperacionxModulo(codigo_modulo:$codigo_modulo){
            respuesta{
              registros{
                modulo_codigo
                modulo_nombre
                operacion_codigo
                operacion_nombre
                fecha_creacion
                activado
              }
            }
          }
        }
      }
      `,
      variables: {
        "codigo_modulo":codigo_modulo
      },
      fetchPolicy: 'network-only',
    }, function(respuesta) {
      self.operacionModuloList = respuesta.data.operacion_modulo.obtenerOperacionxModulo.respuesta.registros;
      self.optionsOperacion = [];
      var sel: any;
      self.operacionModuloList.forEach(element => {
        if(element.activado == true){
          sel = { value: element.operacion_codigo, label: element.operacion_nombre };
          self.optionsOperacion.push(sel);
        }
      });
    });
  }

  obtenerOperacionModuloRol(codigo_rol:number){
    let self = this;
    self.client.query({
      query: gql`
      query($codigo_rol:Decimal){
        rol_operacion{
          obtenerOperacionxModuloxRol(codigo_rol:$codigo_rol){
            respuesta{
              registros{
                rol_codigo
                categoria_codigo
                categoria_nombre
                icono
                modulo_codigo
                modulo_nombre
                endpoint
                operacion_codigo
                operacion_nombre
                orden_modulo
                escabecera
              }
            }
          }
        }
      }
      `,
      variables: {
        "codigo_rol":codigo_rol
      },
      fetchPolicy: 'no-cache',
    },
      function (respuesta) {
        self.rolOperacionModuloList = respuesta.data.rol_operacion.obtenerOperacionxModuloxRol.respuesta.registros;
      });
  }

  agregarOperacion(){
    let rol_codigo= this.formulario.controls["codigo"].value;
    let categoria_codigo= this.formulario.controls["categoria"].value;
    let categoria_nombre = "";
    let icono = "";
    let modulo_codigo= this.formulario.controls["modulo"].value;
    let modulo_nombre = "";
    let endpoint = "";
    let operacion_codigo = this.formulario.controls["operacion"].value;
    let operacion_nombre = "";
    let orden_modulo = 0;
    let escabecera= false;

    var sel: any;
    var arr= [];
    var arr2= [];
    
    if (operacion_codigo == null ) {
      return;
    }
    
    if (operacion_codigo.toString() == "" ) {
      return;
    }

    this.categoriaList.forEach(element=>{
      if(element.codigo == this.formulario.controls["categoria"].value){
        categoria_nombre = element.nombre;
        icono=element.icono;
      }
    });
    this.moduloList.forEach(element=>{
      if(element.codigo == this.formulario.controls["modulo"].value){
        modulo_nombre = element.nombre;
        endpoint = element.endpoint;
        orden_modulo = element.orden;
      }
    });

    this.operacionModuloList.forEach(element=>{
      if(element.operacion_codigo == this.formulario.controls["operacion"].value){
        operacion_nombre = element.operacion_nombre;
      }
    });
    
    for (let item of this.rolOperacionModuloList){
      arr =  [item["operacion_codigo"], item["operacion_nombre"] ]; 
      arr2 = [item["modulo_codigo"], item["modulo_nombre"]];
      var idx = arr.indexOf(operacion_codigo);
      var idx2 = arr2.indexOf(modulo_codigo);
      if(idx != -1){
        if(idx2 != -1){
          alert('La Operacion ya se encuentra agregada');
          return;
        }
      }
    }
    sel= {rol_codigo, categoria_codigo, categoria_nombre, icono, modulo_codigo, modulo_nombre, endpoint, operacion_codigo, operacion_nombre, orden_modulo, escabecera };
    this.rolOperacionModuloList.push(sel);
    this.formulario.get('operacion').setValue("");
    //console.log(this.rolOperacionModuloList);
  }

  eliminarOperacion(index){
    this.rolOperacionModuloList.splice(index, 1);
  }

  insertarOperacion(rolOperacionModuloList: rol_operacionJoin[], codigo_rol:number) {
    for (var i = 0; i < rolOperacionModuloList.length; i++) {
      rolOperacionModuloList[i].rol_codigo= codigo_rol;
      delete rolOperacionModuloList[i]["__typename"];
      delete rolOperacionModuloList[i].categoria_codigo;
      delete rolOperacionModuloList[i].categoria_nombre;
      delete rolOperacionModuloList[i].icono;
      delete rolOperacionModuloList[i].modulo_nombre;
      delete rolOperacionModuloList[i].endpoint;
      delete rolOperacionModuloList[i].operacion_nombre;
      delete rolOperacionModuloList[i].orden_modulo;
      delete rolOperacionModuloList[i].escabecera;
     }
     let self = this;
     var bodyx =  rolOperacionModuloList;
     this.client.mutate({
      mutation: gql`
      mutation($entidad:rol_operacionListInputType, $codigo_rol:Decimal){
        rol_operacion{
          guardarOperacionxModuloxRol(entidad:$entidad, codigo_rol:$codigo_rol){
            mensajes{
              codigo
              tipo
              contexto
              texto
            }  
          }
        }
      }
      `,
      variables: {
        "entidad": {
          "objet":bodyx
        },
        "codigo_modulo": codigo_rol
      }
    },
    function (mensajes) {
      if (mensajes.data.rol_operacion.guardarOperacionxModuloxRol.mensajes != undefined) {
        setTimeout(() => self.obtenerOperacionModuloRol(codigo_rol), 1000);
      }
    });
  }

  refrescarOperacion(rolOperacionModuloList: rol_operacionJoin[]) {
    let codigo_rol = this.formulario.controls["codigo"].value;
    for (var i = 0; i < rolOperacionModuloList.length; i++) {
      rolOperacionModuloList[i].rol_codigo= codigo_rol;
      delete rolOperacionModuloList[i]["__typename"];
      delete rolOperacionModuloList[i].categoria_codigo;
      delete rolOperacionModuloList[i].categoria_nombre;
      delete rolOperacionModuloList[i].icono;
      delete rolOperacionModuloList[i].modulo_nombre;
      delete rolOperacionModuloList[i].endpoint;
      delete rolOperacionModuloList[i].operacion_nombre;
      delete rolOperacionModuloList[i].orden_modulo;
      delete rolOperacionModuloList[i].escabecera;
     }
     let self = this;
     var bodyx =  rolOperacionModuloList;
     this.client.mutate({
      mutation: gql`
      mutation($entidad:rol_operacionListInputType, $codigo_rol:Decimal){
        rol_operacion{
          guardarOperacionxModuloxRol(entidad:$entidad, codigo_rol:$codigo_rol){
            mensajes{
              codigo
              tipo
              contexto
              texto
            }  
          }
        }
      }
      `,
      variables: {
        "entidad": {
          "objet":bodyx
        },
        "codigo_rol": codigo_rol
      }
    },
    function (mensajes) {
      if (mensajes.data.rol_operacion.guardarOperacionxModuloxRol.mensajes != undefined) {
        setTimeout(() => self.obtenerOperacionModuloRol(codigo_rol), 1000);
      }
    });
  }

  insertarClonOperacion(codigoClon_rol:number, codigo_rol:number ){
     let self = this;
     this.client.mutate({
      mutation: gql`
      mutation($codigoClon_rol:Decimal, $codigo_rol:Decimal){
        rol_operacion{
          guardarClonOperacionxModuloxRol(codigoClon_rol:$codigoClon_rol, codigo_rol:$codigo_rol){
            mensajes{
              codigo
              tipo
              contexto
              texto
            }  
          }
        }
      }
      `,
      variables: {
        "codigoClon_rol": codigoClon_rol,
        "codigo_rol": codigo_rol
      }
    },
    function (mensajes) {
      if (mensajes.data.rol_operacion.guardarClonOperacionxModuloxRol.mensajes != undefined) {
        setTimeout(() => self.obtenerOperacionModuloRol(codigo_rol), 1000);
      }
    });
  }

  showModalAgregar() {
    const self = this;
    let codigo_operacion = 3
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.agregarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  showModalModificar() {
    const self = this;
    let codigo_operacion = 2
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.editarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  
  permitirCambioEstado(rol: rol) {
    const self = this;
    let codigo_operacion = 4
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.cambiaEstado(rol);
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
  showModalClonar() {
    const self = this;
    let codigo_operacion = 5
    this.client.query({
      query: gql`
      query ($rut_usu:Decimal, $codgo_modulo:Decimal, $cod_operacion:Decimal)
      {
        rol_operacion
        {
          operacionPermitida(rut_usu:$rut_usu, codgo_modulo: $codgo_modulo, cod_operacion:$cod_operacion)
          {
            mensajes
            {
              texto
              tipo
            }
            respuesta
          }
        }
      }
        `,
      variables: {
        'rut_usu': self.rut_usuario,
        'codgo_modulo': self.codgo_modulo,
        'cod_operacion': codigo_operacion,
      },
      fetchPolicy: 'no-cache',
    }, function (respuesta) {
      const notificacion: NotificacionGenerica<string> = NotificacionGenerica.parse(respuesta.data.rol_operacion.operacionPermitida);
      if (notificacion.mensajes[0].tipo == TipoMensaje.SUCCESS) {
        self.clonarModal.show();
      }
      else {
        alert(notificacion.mensajes[0].texto);
      }
    });
  }
}
